// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, HostListener, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UtilConfig} from "../../../../autenticacion/servicios/UtilConfig";
import {LogRecibido} from "./recursos/modelo/LogRecibido";
import * as moment from 'moment';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';

import {ScrollEvent} from 'ngx-scroll-event';
import {FormControl, FormGroup} from "@angular/forms";
import {WebServices} from "../../../recursos/modelo/consumerModel/web-services.enum";
import {ConsumerService} from "../../../recursos/servicio/consumer.service";
import {isNullOrUndefined} from "util";

import {MatChipInputEvent, MatSnackBar} from '@angular/material';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Ng2DeviceService} from "ng2-device-detector";
import {MatTableDataSource} from "@angular/material/table";
import {LogEmisor} from "../logEmisorTmp/recursos/modelo/LogEmisor";
import {SelectionModel} from "@angular/cdk/collections";
import {MatPaginator} from "@angular/material/paginator";
import {LayoutService} from "../../../recursos/servicio/layout.service";

declare var swal: any;

declare const $: any;

@Component({
    moduleId: module.id,
    selector: 'app-logSFTP',
    templateUrl: './view/list-logSFTP.component.html',
    styleUrls: ['./css/list-logSFTP.component.css'],
    providers: [ConsumerService]
})
export class LogSFTPComponent implements OnInit, OnChanges {
    // ITEM DEL CRUD
    origenCRUD = "documento";

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─
    // variables de pantalla
    todos = false;
    URL_GET_LOG_DESCARGA_MASIVA;
    URL_GET_LOG_IMPRESION_MASIVA;
    descargar = false;
    activoDescarga = false;
    mensaje = "INFO DE LA TABLA PSE_CONTROL";
    loading = false;
    noHayResultados = false;
    es;
    to = "0";
    max = "9999999";
    showDetail = false;
    cargandoConsulta = false;
    cargandoList = false;
    reenviarCorreo: boolean = false;
    documentType: any[] = [];
    monedaType: any[] = [];
    form: FormGroup;
    searchField: FormControl;
    emisor = "";
    empresaAdministradora = false;
    itemSelected : any;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_LOG_RECIBIDOS_LISTAR: false,
        ROLE_LOG_RECIBIDOS_DESCARGAR_PDF: false,
        ROLE_LOG_RECIBIDOS_DESCARGAR_RAR: false,
        ROLE_LOG_RECIBIDOS_VALIDAR_CONTRA_SUNAT: false,
        ROLE_LOG_RECIBIDOS_DESCARGAR_XML: false
    };
    //variables modelo
    ItemLista: any[];
    ItemListaDetail: any[];
    ItemSelected: LogRecibido;
    rangeDates: Date[];
    locale = 'es';
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig>;
    // scroll list
    scrollItems: LogRecibido[] = [];
    readonly bufferSize: number = 50;
    timer: any;
    loadingTexto: boolean = false;
    loadingTextoRefinir: boolean = false;
    totalRegistros = 0;
    inicial = true;
    visible: boolean = true;
    selectable: boolean = true;
    removable: boolean = true;
    addOnBlur: boolean = true;
    // Enter, comma
    separatorKeysCodes = [ENTER, COMMA];
    correosReenvio = [];
    selectedMovil: boolean = false;

    displayedColumns;
    displayedColumnsDetail;

    dataSource = new MatTableDataSource<any>();
    dataSourceDetail = new MatTableDataSource<any>();

    selection = new SelectionModel<any>(true, []);
    @ViewChild("paginatorLote") paginatorLote: MatPaginator;
    @ViewChild("paginatorDetail") paginatorDetail: MatPaginator;

    private colorText = null;
    private colorTitle = null;

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dataSource.data.forEach(row => this.selection.select(row));
    }

    /**
     * Set the paginator after the view init since this component will
     * be able to query its view for the initialized paginator.
     */
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginatorLote;
        this.dataSourceDetail.paginator = this.paginatorDetail;
        this.paginatorLote.page.subscribe(
            (event) => this.msjFinBusqueqda())
        this.paginatorLote._intl.itemsPerPageLabel = 'Documentos por paginas ';
    }

    obtenerIdSelection() {
        return this.selection.selected.map((task) => task.id);
    }


    msjFinBusqueqda() {
        if (!this.paginatorLote.hasNextPage())
            this.snackBar.open('Si no conseguiste el documento, refine tu busqueda.', null, {duration: 4000})
    }
    msjFinBusqueqdaDetail() {
        if (!this.paginatorDetail.hasNextPage())
            this.snackBar.open('Si no conseguiste el documento, refine tu busqueda.', null, {duration: 4000})
    }

    constructor(private consumer: ConsumerService,
                private route: ActivatedRoute,
                private router: Router,
                private layout: LayoutService,
                private snackBar: MatSnackBar,
                public jwtUtil: UtilConfig,
                private _localeService: BsLocaleService,
                private deviceService: Ng2DeviceService) {
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);

        this._localeService.use(this.locale);

        this.displayedColumns = ['filename', 'nroRegistros', 'fecha'];
        this.displayedColumnsDetail = ['fileContent', 'status'];

        this.ItemLista = [];
        this.ItemListaDetail = [];


        this.es = jwtUtil.CONFIG_ES_CALENDAR;

        this.emisor = jwtUtil.getCurrentUser().customer.id;
        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT

        if (this.emisor == jwtUtil.ESCON_CUSTOMER)
            this.empresaAdministradora = true;

        // VERIFICA LOS PERMISOS DEL LOG LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        if (this.authorities.ROLE_LOG_RECIBIDOS_LISTAR)
                this.realizarBusqueda();

        if (this.jwtUtil.getColorText()) {
            this.colorText = this.jwtUtil.getColorText();
        }
        this.layout.getColorText().subscribe(colorText => {
            this.colorText = colorText;
        });

        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }
        this.layout.getColorTitle().subscribe(colorTitle => {
            this.colorTitle = colorTitle;
        });
    }

    @HostListener('window:keyup.escape', ['$event'])
    keyEvent(event: KeyboardEvent) {
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
        $.each(this.ItemLista, function (pos, item) {
            item.seleccionado = false;
        });
    }

    add(event: MatChipInputEvent): void {
        let input = event.input;
        let value = event.value;
        // Add our fruit
        if ((value || '').trim() && this.validarEmail(value)) {
            this.correosReenvio.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    validarEmail(valor) {
        if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(valor)) {
            return true;
        } else {
            this.snackBar.open('La dirección de email es incorrecta!.', null, {duration: 2000});
            return false;
        }
    }

    remove(correo: any): void {
        let index = this.correosReenvio.indexOf(correo);

        if (index >= 0) {
            this.correosReenvio.splice(index, 1);
        }
    }

    public handleScroll(event: ScrollEvent) {
        if (event.isReachingBottom) {
            this.fetchMore(event);
        }
        if (event.isWindowEvent) {
            this.fetchMore(event);
            console.log(`This event is fired on Window not on an element.`);
        }

    }

    fetchMore(event) {
        if (this.scrollItems.length != this.ItemLista.length) {
            this.loadingTexto = true;
            this.fetchNextChunk(this.scrollItems.length, this.bufferSize, event).then(chunk => {
                this.scrollItems = this.scrollItems.concat(chunk);
                this.loadingTexto = false;
            }, () => this.loadingTexto = false);
        } else {
            this.loadingTexto = false;
            this.loadingTextoRefinir = true;
        }
    }

    fetchNextChunk(skip: number, limit: number, event?: any): Promise<LogRecibido[]> {
        return new Promise((resolve, reject) => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (skip < this.ItemLista.length) {
                    return resolve(this.ItemLista.slice(skip, skip + limit));
                }
                reject();
            }, 1000 + Math.random() * 1000);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        this.reset();
    }

    reset() {
        this.fetchNextChunk(0, this.bufferSize, {}).then(chunk => {
            this.scrollItems = chunk;
            this.cargandoList = false;
        });
    }

    ngOnInit() {

        if (this.deviceService.isMobile() || this.deviceService.isTablet())
            this.selectedMovil = true;


        this.searchField = new FormControl();
        this.searchField.valueChanges
            .debounceTime(1000)
            .distinctUntilChanged();

    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴       


    refrescar() {
        this.realizarBusqueda();
    }


    listar() {
        this.router.navigate(['/content', {outlets: {'second': ['SFTP']}}]);
    }

    toggleFiltros() {
        this.showDetail = !this.showDetail;
    }




    cerrarOperacionMasiva() {
        $.each(this.ItemLista, (pos, item) => {
            item.seleccionado = false;
        });
        $.each(this.scrollItems, (pos, item) => {
            item.seleccionado = false;
        });
        this.activoDescarga = false;
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐

    cerrarDetalle() {
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
        $.each(this.ItemLista, function (pos, log) {
            log.seleccionado = false;
        });
    };

    consulta(item) {
            this.itemSelected = item;
            $("ul#slide-out").addClass("open");
            $("i.cerrarAleta").addClass("open");
            this.reenviarCorreo = false;
            this.correosReenvio = [];
            item.seleccionado = !item.seleccionado;
            this.cargandoConsulta = true;
            this.consumer.getById<any>("log", item.id, WebServices.URL_GET_LOG_SFTP)
                .subscribe(result => {
                    this.showDetail = true;
                    this.ItemListaDetail = result["logs"][0];
                    this.dataSourceDetail.data = this.ItemListaDetail;
                    this.cargandoConsulta = false;
                    if (this.ItemListaDetail.length == 0){
                        this.mensaje = 'No se consiguio detalle de este lote';
                        this.colorTitle = 'red';
                    }

                }, err => {
                    this.showDetail = false;
                    this.dataSourceDetail.data = [];
                    this.ItemListaDetail = [];
                    this.cargandoConsulta = false;
                    this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar el documento", this.router)
                });
    }


//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘
    public realizarBusqueda() {
        debugger;
        // LLAMADO AL SERVICIO
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
        this.cargandoList = true;
        this.consumer.get<any>(WebServices.URL_LIST_LOG_SFTP)
            .subscribe(result => {
                this.selection.clear();
                this.ItemLista = result["logs"][0];
                this.ItemListaDetail = [];
                this.dataSource.data = this.ItemLista;
                this.dataSourceDetail.data = [];
                if ((this.ItemLista != null) && (this.ItemLista.length == 0)) {
                    this.dataSource.data = [];
                    this.dataSourceDetail.data = [];
                    this.mensaje = "NO HAY PROCESOS EN CURSO O PENDIENTES ";
                }
                this.totalRegistros = result["rowsCount"];
                this.cargandoList = false;
            }, err => {
                this.selection.clear();
                this.ItemLista = [];
                this.ItemListaDetail = [];
                this.dataSource.data = [];
                this.dataSourceDetail.data = [];
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar el documento", this.router)
            });
    }


}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/logSFTP/list-logSFTP.component.ts